import { Box } from '@mui/material';
import { EditIcon, DeleteIcon } from './icons/Icons';
import { useMemo } from 'react';

const ActionsCell = ({ entityId, onEditClick, onDeleteClick, customActions = [] }) => {
    const actions = useMemo(() => [
        {
            id: 'edit',
            position: 10,
            icon: EditIcon,
            onClick: onEditClick,
            disabled: false
        },
        {
            id: 'delete',
            position: 20,
            icon: DeleteIcon,
            onClick: onDeleteClick,
            disabled: false
        }
    ], [onEditClick, onDeleteClick]);

    const getFinalActions = () => {
        const actionMap = new Map(actions.map(action => [action.id, action]));

        customActions.forEach(customAction => {
            if (actionMap.has(customAction.id)) {
                actionMap.set(customAction.id, { ...actionMap.get(customAction.id), ...customAction });
            } else {
                actionMap.set(customAction.id, customAction);
            }
        });

        return Array.from(actionMap.values()).sort((a, b) => a.position - b.position);
    };

    const finalActions = getFinalActions();

    const onClick = (evt, callback) => {
        evt.preventDefault();

        callback(entityId);
    }

    return <Box className='actionsCell' sx={{ display: 'flex', flexDirection: 'row' }} >
        {finalActions.map((action) => {
            const Icon = action.icon;
            return !action.disabled && <Icon key={action.id} onClick={(evt) => onClick(evt, action.onClick)} />
        })}
    </Box>
}

export default ActionsCell;